import * as types from '../../actionTypes';

const initialState = {
    printInvoiceData: [],
    error: {},
    loading: false,
}


export  const printInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.PRINT_INVOICE_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.PRINT_INVOICE_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                printInvoiceData: action.payload,
                loading: false,
                error: {}
            }
        case types.PRINT_INVOICE_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                printInvoiceData: []
            }
        
        default:
            return state;
    }
}